//import RoadmapCard from "../components/RoadmapCard";

export const DevRoles = [
  { title: "FrontEnd Developer" },
  { title: "BackEnd Developer" },
  { title: "Full Stack Developer" },
  { title: "Mobile App Developer" },
  { title: "Game Developer" },
  { title: "Embedded System Developer" }
];

export const Cloud = [
  {title: "Cloud Engineer"},
  {title: "DevOps Engineer"},
  {title: "Site Reliability Engineer"},
  {title: "Platform Engineer"}
];

export const Cybersecurity = [
  {title: "Cybersecurity Analyst"},
  {title: "Ethical Hacker"},
  {title: "SOC Analyst"},
  {title: "Cloud Security Engineer"},
  {title: "Security Architect"}
];

export const DataAI = [
  {title: "Data Analyst"},
  {title: "Data Engineer"},
  {title: "Data Scientist"},
  {title: "Machine learning Engineer"},
  {title: "AI Engineer"},
];

export const Testing = [
  {title: "QA Engineer"},
  {title: "Test Automation Engineer"},
  {title: "Performance Tester"}
];

export const Design = [
  {title: "UI-UX Designer"},
  {title: "Product Designer"},
  {title: "Game Designer"}
];